const myUrl = 'https://brianoluoch.netlify.app';

export default myUrl;